import { render, staticRenderFns } from "./opintooppaat.vue?vue&type=template&id=c9f5d184&scoped=true&"
import script from "./opintooppaat.vue?vue&type=script&lang=ts&"
export * from "./opintooppaat.vue?vue&type=script&lang=ts&"
import style0 from "./opintooppaat.vue?vue&type=style&index=0&id=c9f5d184&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c9f5d184",
  null
  
)

export default component.exports